import * as React from 'react'

import { useTimelineData } from '../context/DataContext'
import { ExistingDelegationBlock } from '../blocks/ExistingDelegationBlock'
import { LayerWrapper } from './LayerWrapper'
import { LayerProps } from './types'
import { BOTTOM_PADDING } from '../utils/layout'

const ExistingDelegationsLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const { existingDelegations } = useTimelineData()

  return (
    <LayerWrapper zIndex={zIndex} paddingBottom={BOTTOM_PADDING}> 
      {existingDelegations.map((item, index) => (
        <ExistingDelegationBlock
          key={index}
          existingDelegation={item}
          index={index}
        />
      ))}
    </LayerWrapper>
  )
}

export default ExistingDelegationsLayer
